module.exports = require('../dist/pure');
